import antdEs from "antd/locale/es_ES";
import saMessages from "../locales/es_ES.json";

const saLang = {
  messages: {
    ...saMessages
  },
  antd: antdEs,
  locale: 'es'
};
export default saLang;
